import { render, staticRenderFns } from "./direct_dispatch.vue?vue&type=template&id=56ca37ba"
import script from "./direct_dispatch.vue?vue&type=script&lang=js"
export * from "./direct_dispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports